import React from "react";
import { Form, Input, Checkbox, Button, Card } from "lib/ui";

const MyForm = ({ form, onFinish, initialValues }) => {
  return (
    <Form
      form={form}
      name="user_form"
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <Card title="User Information">
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, message: "Email is required" }]}
        >
          <Input type="email" placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="mobile_number"
          label="Mobile Number"
          rules={[{ required: true, message: "Mobile number is required" }]}
        >
          <Input placeholder="Mobile Number" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: "Password is required" }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>
      </Card>

      <Form.Item name="assigned" valuePropName="checked" label="Assigned?">
        <Checkbox disabled>Assigned?</Checkbox>
      </Form.Item>
      <Form.Item name="is_online" valuePropName="checked" label="Online?">
        <Checkbox>Is Online?</Checkbox>
      </Form.Item>
      <Form.Item name="is_verified" valuePropName="checked" label="Verified?">
        <Checkbox>Is Verified?</Checkbox>
      </Form.Item>
      <Form.Item
        name="latitude"
        label="Latitude"
        rules={[{ required: true, message: "Valid latitude is required" }]}
      >
        <Input type="number" placeholder="Latitude" />
      </Form.Item>
      <Form.Item
        name="longitude"
        label="Longitude"
        rules={[{ required: true, message: "Valid longitude is required" }]}
      >
        <Input type="number" placeholder="Longitude" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default MyForm;
